export const apiPath = '/v2/facility_users';
const actionType = 'FACILITY_USERS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
